import { useQuery } from '@tanstack/react-query';

import { getDeals, getSandboxDeals } from '../../../../api';
import { PageParams } from '../../../../types/pagination';
import { StrategyStatus } from '../../../../types/strategy';

export const useLoadDeals = (
  id: string | undefined,
  strategyStatus: StrategyStatus | undefined,
  pageParams: PageParams,
) => {
  return useQuery({
    queryKey: ['loadDeals', id, strategyStatus, pageParams],
    queryFn: () => {
      const params = {
        strategyId: id,
        data: pageParams,
      };

      if (strategyStatus === StrategyStatus.Standard || strategyStatus === StrategyStatus.Closed) {
        return getDeals(params);
      } else {
        return getSandboxDeals(params);
      }
    },
    enabled: !!id,
    refetchInterval: 10000,
    refetchIntervalInBackground: true,
  });
};
